/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice(value) {
    if (!('LocalizedPrice' in value) || value['LocalizedPrice'] === undefined)
        return false;
    if (!('Price' in value) || value['Price'] === undefined)
        return false;
    if (!('PriceBeforeDiscount' in value) || value['PriceBeforeDiscount'] === undefined)
        return false;
    if (!('PriceDiscount' in value) || value['PriceDiscount'] === undefined)
        return false;
    if (!('PriceBeforeBeautify' in value) || value['PriceBeforeBeautify'] === undefined)
        return false;
    if (!('CurrencySymbol' in value) || value['CurrencySymbol'] === undefined)
        return false;
    if (!('CurrencyIso4217' in value) || value['CurrencyIso4217'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'LocalizedPrice': json['localized_price'],
        'Price': json['price'],
        'PriceBeforeDiscount': json['price_before_discount'],
        'PriceDiscount': json['price_discount'],
        'PriceBeforeBeautify': json['price_before_beautify'],
        'CurrencySymbol': json['currency_symbol'],
        'CurrencyIso4217': json['currency_iso4217'],
    };
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'localized_price': value['LocalizedPrice'],
        'price': value['Price'],
        'price_before_discount': value['PriceBeforeDiscount'],
        'price_discount': value['PriceDiscount'],
        'price_before_beautify': value['PriceBeforeBeautify'],
        'currency_symbol': value['CurrencySymbol'],
        'currency_iso4217': value['CurrencyIso4217'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice.js.map